import {
  parse,
  parsePhoneNumber,
  format,
  isValidNumber,
  getCountries,
  getCountryCallingCode,
  CountryCode,
} from 'libphonenumber-js';

export const getCountryCodes = () =>
  getCountries().map((country) => ({
    country,
    callingCode: getCountryCallingCode(country),
  }));

export const toE164 = (
  number = '',
  defaultRegionCallingCode: CountryCode = 'DE'
) => {
  const parsedNumber = parse(number, {
    // default country to use for phone number parsing and validation
    // (if no country code could be derived from the phone number)
    defaultCountry: defaultRegionCallingCode,
  });
  return format(parsedNumber, 'E.164');
};

export const toNational = (number = '', defaultRegionCallingCode?: string) => {
  if (!number) {
    return '';
  }
  const parsedNumber = parsePhoneNumber(number);
  return parsedNumber.country === defaultRegionCallingCode
    ? parsedNumber.formatNational()
    : parsedNumber.formatInternational();
};

export const getPhoneNumberUri = (number: string) => {
  if (!number) {
    return '';
  }
  const parsedNumber = parsePhoneNumber(number);
  return parsedNumber.getURI();
};

export const isValidPhoneNumber = (
  number = '',
  defaultRegionCallingCode: CountryCode = 'DE'
) =>
  // default country to use for phone number parsing and validation
  // (if no country code could be derived from the phone number)
  isValidNumber(number, defaultRegionCallingCode);
